import AoneService from "../axiosbase";

export const getCodPayables = async (data) => {
  try {
    return await AoneService.post(`cod-automation/api/v1/cod/payable/`, data);
  } catch (error) {
    return error;
  }
}; 

export const getPayableAmount = async (customer, from, to, destinationCountry, signal) => {
  try {
    return await AoneService.get(`cod-automation/api/v1/cod/payable/${customer}?from=${from}&to=${to}&destinationCountry=${destinationCountry}`,
        { signal: signal }
    );
  } catch (error) {
    return error;
  }
};

export const generateCodPayable = async (data) => {
  try {
    return await AoneService.post(`cod-automation/api/v1/cod/payable/generate`, data);
  } catch (error) {
    return error;
  }
};

export const sendCodBulkEmail = async (data) => {
  try {
    return await AoneService.post(`cod-automation/api/v1/cod/payable/send/email`, data);
  } catch (error) {
    return error;
  }
};

/* The consignments of a payable are paged by cursor: the response carries a
   `nextCursor` that has to be handed back to ask for the page after it. The
   first page is the one asked for without a cursor. */
export const getCodPayableDetails = async (customer, from, to, destinationCountry, size = 20, cursor = null) => {
  try {
    let endpoint = `cod-automation/api/v1/cod/payable/${customer}/details?customers=${customer}&from=${from ?? 0}&to=${to ?? 0}&destinationCountry=${destinationCountry}&size=${size}`;
    if (cursor) endpoint += `&cursor=${encodeURIComponent(cursor)}`;
    return await AoneService.get(endpoint);
  } catch (error) {
    return error;
  }
};

/* A payable that has already been generated is fetched by its summary id
   alone; the endpoint takes no paging of its own, so it answers with the whole
   payable at once. */
export const getCodPayableBySummaryId = async (summaryId) => {
  try {
    return await AoneService.get(`cod-automation/api/v1/cod/payable?summaryId=${summaryId}`);
  } catch (error) {
    return error;
  }
};

export const getCodPayableExcel = async (summaryId) => {
  try {
    return await AoneService.get(`cod-automation/api/v1/cod/payable//download/${summaryId}`, { responseType: "blob" });
  } catch (error) {
    return error;
  }
};

export const addAdjustmentEntry = async (data) => {
  try {
    return await AoneService.patch(`cod-automation/api/v1/cod/payable/adjustment`, data);
      } catch (error) {
      return error;
    }
  }

export const getAllBankCharges = async () => {
  try {
    return await AoneService.get(`cod-automation/api/v1/bank-charges/`);
  } catch (error) {
    return error;
  }
};

export const getBanksLookup = async () => {
  try {
    return await AoneService.get(`cod-automation/api/v1/lookups/Banks`);
  } catch (error) {
    return error;
  }
};

export const addBankCharges = async (data) => {
  try {
    return await AoneService.post(`cod-automation/api/v1/bank-charges/`, data);
  } catch (error) {
    return error;
  }
}; 

export const editBankCharges = async (id, data) => {
  try {
    return await AoneService.put(`cod-automation/api/v1/bank-charges/${id}`, data);
  } catch (error) {
    return error;
  }
}; 

export const deleteBankCharges = async (id) => {
  try {
    return await AoneService.delete(`cod-automation/api/v1/bank-charges/${id}`);
  } catch (error) {
    return error;
  }
}; 

export const getCodArchiveSummary = async (data) => {
  try {
    return await AoneService.post(`cod-automation/api/v1/cod/archive/summary`, data);
  } catch (error) {
    return error;
  }
};

export const exportCodArchiveSummary = async (data) => {
  try {
    return await AoneService.post(`cod-automation/api/v1/cod/archive/summary/export`, data,{ responseType: "blob" });
  } catch (error) {
    return error;
  }
};

export const uploadCodAttachment = async (customerAccount, file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('customerAccount', customerAccount);
  const response = await AoneService.post(
    `cod-automation/api/v1/cod/attachment`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  if (response?.data?.status && response.data.status !== 'SUCCESS') {
    throw new Error(response?.data?.msg || 'Upload failed');
  }
  return response;
};

export const deleteCodAttachment = async (attachmentId) => {
  return await AoneService.delete(`cod-automation/api/v1/cod/attachment/${attachmentId}`);
};

export const uploadBankReceipt = async (summaryId, customerAccount, file, sendEmail = false) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    return await AoneService.post(
      `cod-automation/api/v1/bank-receipts/upload?summaryId=${summaryId}&customerAccount=${customerAccount}&sendEmail=${sendEmail}`,
      formData,
      {
        transformRequest: (data, headers) => {
          headers.delete('Content-Type');
          return data;
        },
      }
    );
  } catch (error) {
    return error;
  }
};

export const downloadBankReceipt = async (summaryId, customerAccount) => {
  try {
    return await AoneService.get(
      `cod-automation/api/v1/bank-receipts/download?summaryId=${summaryId}&customerAccount=${customerAccount}`,
      { responseType: 'blob' }
    );
  } catch (error) {
    return error;
  }
};

export const sendCodEmailWithFile = async (data, file) => {
  const formData = new FormData();
  formData.append('file', file);
  if (data.summaryId != null) formData.append('summaryId', String(data.summaryId));
  formData.append('customerAccount', data.customerAccount ?? '');
  formData.append('customerName', data.customerName ?? '');
  formData.append('payableAmount', String(data.payableAmount ?? 0));
  if (data.fromDate != null) formData.append('fromDate', String(data.fromDate));
  if (data.toDate != null) formData.append('toDate', String(data.toDate));
  const response = await AoneService.post(
    `cod-automation/api/v1/cod/payable/send/email`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  if (response?.data?.status && response.data.status !== 'SUCCESS') {
    throw new Error(response?.data?.msg || 'Failed to send email');
  }
  return response;
};